var exports = {
  "YW": "x31de4314--46e9f5--checkbox-wrapper",
  "kv": "x31de4314--46e9f5--checkbox",
  "D8": "x31de4314--46e9f5--checkbox-label",
  "Th": "x31de4314--46e9f5--checkbox-label-text",
  "ZX": "x31de4314--46e9f5--checkbox-description",
  "dh": "x31de4314--46e9f5--checkbox-adornment",
  "in": "x31de4314--46e9f5--focused",
};

module.exports = exports;
